import { render, staticRenderFns } from "./CustomOwnerFormField.vue?vue&type=template&id=0ff8da12"
import script from "./CustomOwnerFormField.vue?vue&type=script&lang=js"
export * from "./CustomOwnerFormField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports